<template>
  <transition name="fade" mode="out-in">
    <ucar-mask v-if="showShare">
      <div class="share-wrapper" v-if="!showQR && !isWeixin">
        <div class="share-header">分享到</div>
        <div class="share-body">
          <div class="share-item" @click="weiboShare">
            <div class="icon weibo"></div>
            <span>微博</span>
          </div>
          <div class="share-item" @click="qqShare">
            <div class="icon qq"></div>
            <span>QQ空间</span>
          </div>
          <div class="share-item copy" @click.prevent>
            <div class="icon copy"></div>
            <span>复制链接</span>
          </div>
          <div class="share-item" @click="showQR = true">
            <div class="icon QR"></div>
            <span>面对面邀请</span>
          </div>
        </div>
        <div class="share-cancel-wrapper" @click="close">取消</div>
      </div>
      <div class="share-weixin-wrapper" @click="close" v-if="!showQR && isWeixin">
        <img class="weixin-arrow" src="../assets/share-weixin-arrow.png">
        <p class="weixin-tips">点击右上角“…”分享给朋友</p>
        <span>或</span>
        <p class="QR-title">面对面邀请</p>
        <p class="QR-desc">扫描下方二维码直接报名</p>
        <img class="QR-img" :src="QRUrl">
      </div>
      <div class="share-QR" v-if="showQR">
        <span @click="close">✕</span>
        <h2>欢迎成为神州专车车主</h2>
        <p class="share-QR-desc">扫码立即报名</p>
        <img :src="QRUrl">
      </div>
    </ucar-mask>
  </transition>
</template>

<style lang="stylus" scoped>
@import "../styles/variable.styl";

.share-wrapper {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  color: $ucar_font_color;
  background-color: #fff;
}

.share-cancel-wrapper {
  border-top: 1px solid $ucar_light_border; /*no*/
  width: 100%;
  height: 88px;
  line-height: 88px;
  font-size: $ucar_font_h4;
  text-align: center;
}

.share-header {
  text-align: center;
  font-size: $ucar_font_h4;
  height: 130px;
  line-height: 130px;
}

.share-body {
  box-sizing: border-box;
  background-color: #fff;
  width: 100%;
  display: flex;
  height: 210px;
  padding: 0 0;
  min-width: 0;
  align-items: flex-start;
  justify-content: space-around;
}

.share-item {
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  justify-content: center;

  .icon {
    display: block;
    width: 100px;
    height: 100px;
    border-radius: 20px;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 50px auto;
    border: 1px solid $ucar_light_border; /*no*/
    margin-bottom: 20px;

    &.weibo {
      background-image: url("../assets/share-weibo.png");
    }

    &.qq {
      background-image: url("../assets/share-qq.png");
    }

    &.copy {
      background-image: url("../assets/share-copy.png");
    }

    &.QR {
      background-image: url("../assets/share-QR.png");
    }
  }
}

.share-item span {
  text-align: center;
  font-size: 28px;
  color: #666;
}

.share-weixin-wrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  padding-top: 210px;
  line-height: 1;
  text-align: center;

  p {
    color: #fff;
    font-weight: bolder;
  }

  .weixin-arrow {
    position: absolute;
    width: 110px;
    height: auto;
    top: 30px;
    right: 40px;
  }

  .weixin-tips {
    font-size: $ucar_font_normal;
    margin-bottom: 90px;
  }

  span {
    height: 60px;
    line-height: 60px;
    font-size: $ucar_font_h6;
    width: 60px;
    border-radius: 50%;
    border: 1px solid currentColor; /*no*/
    color: $ucar_price_color;
    font-weight: bolder;
    margin-bottom: 90px;
  }

  .QR-title {
    font-size: $ucar_font_normal;
    margin-bottom: 10px;
  }

  .QR-desc {
    font-size: $ucar_font_h6;
    margin-bottom: 40px;
  }

  .QR-img {
    width: 290px;
    height: 290px;
    box-shadow: 0 0 0 10px rgba(255, 255, 255, 0.5);
  }
}

.share-QR {
  position: absolute;
  padding: 70px 0 50px;
  top: 30%;
  left: 50%;
  transform: translate3d(-50%, 0, 0);
  width: 520px;
  background-color: #fff;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  text-align: center;
  line-height: 1;

  span {
    box-sizing: border-box;
    position: absolute;
    right: 20px;
    top: 20px;
    height: 30px;
    width: 30px;
    color: $ucar_font_assist_color;
  }

  h2 {
    font-size: $ucar_font-h3-5;
    margin-bottom: 20px;
  }

  .share-QR-tips {
    font-size: $ucar_font_normal;
    font-weight: bold;
    color: $ucar_price_color;
    margin-bottom: 40px;
  }

  img {
    width: 290px;
    height: 290px;
    margin-bottom: 40px;
    box-shadow: 0 0 0 10px rgba(0, 0, 0, 0.2);
  }

  .share-QR-desc {
    color: $ucar_price_color;
    font-size: $ucar_font_normal;
    margin-bottom: 40px;
  }
}
</style>

<script>
import Clipboard from 'clipboard'
import { mapGetters } from 'vuex'
import QRtest from '../assets/QRtest.png'
import QRpre from '../assets/QRpre.png'
import QRprod from '../assets/QRprod.png'
export default {
  data () {
    return {
      QRUrl: APP_ENV === 'prod' ? QRprod : (APP_ENV === 'pre' ? QRpre : QRtest),
      isWeixin: /MicroMessenger/i.test(navigator.userAgent),
      clipboard: null,
      showQR: false
    }
  },
  computed: {
    ...mapGetters([
      'vuexIndexUrl'
    ])
  },
  props: ['showShare'],
  methods: {
    qqShare () {
      window.ucarShare.qqShare()
    },
    weiboShare () {
      window.ucarShare.weiboShare()
    },
    close () {
      this.showQR = false
      this.$emit('cancelShare')
    }
  },
  mounted () {
    if (!this.clipboard) {
      setTimeout(() => {
        this.clipboard = new Clipboard('.share-item.copy', {
          text: () => `${location.protocol}//${location.host}${this.vuexIndexUrl}${this.vuexIndexUrl === '/' ? `?ucarfrom=${this.vuexFrom}` : `&ucarfrom=${this.vuexFrom}`}`
        })
        this.clipboard.on('success', () => {
          this.close()
          this.$alert('报名网址已复制到你的剪贴板中:)')
        })
      }, 200)
    }
  },
  beforeDestroy () {
    if (this.clipboard) this.clipboard.destroy()
  }
}
</script>
